import { render, staticRenderFns } from "./frontdesk.vue?vue&type=template&id=033eb308&scoped=true"
import script from "./frontdesk.vue?vue&type=script&lang=js"
export * from "./frontdesk.vue?vue&type=script&lang=js"
import style0 from "./frontdesk.vue?vue&type=style&index=0&id=033eb308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033eb308",
  null
  
)

export default component.exports